import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Dashboard,
  LocationOn,
  CardTravel,
  Hiking,
  Article,
  People,
  LocalOffer,
  EventNote,
  Settings,
  Menu,
  ChevronLeft,
  Logout,
  Hotel
} from '@mui/icons-material';
import { logoutUser, getCurrentUser } from '../../utils/auth';

const Sidebar = ({ collapsed, toggleSidebar }) => {
  const location = useLocation();
  const currentUser = getCurrentUser();
  const [activeDropdown, setActiveDropdown] = useState(null);

  const menuItems = [
    {
      path: '/dashboard',
      icon: <Dashboard className="w-5 h-5" />,
      text: 'Tableau de bord'
    },
    // {
    //   path: '/destinations',
    //   icon: <LocationOn className="w-5 h-5" />,
    //   text: 'Destinations'
    // },
    // {
    //   path: '/packages',
    //   icon: <CardTravel className="w-5 h-5" />,
    //   text: 'Forfaits'
    // },
    // {
    //   path: '/hotels',
    //   icon: <Hotel className="w-5 h-5" />,
    //   text: 'Hôtels'
    // },
    // {
    //   path: '/excursions',
    //   icon: <Hiking className="w-5 h-5" />,
    //   text: 'Excursions'
    // },
    // {
    //   path: '/offers',
    //   icon: <LocalOffer className="w-5 h-5" />,
    //   text: 'Offres'
    // },
    {
      path: '/bookings',
      icon: <EventNote className="w-5 h-5" />,
      text: 'Réservations'
    },
    // {
    //   path: '/blog',
    //   icon: <Article className="w-5 h-5" />,
    //   text: 'Blog'
    // },
    // {
    //   path: '/users',
    //   icon: <People className="w-5 h-5" />,
    //   text: 'Utilisateurs'
    // },
    // {
    //   path: '/settings',
    //   icon: <Settings className="w-5 h-5" />,
    //   text: 'Paramètres'
    // },
  ];

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <div className={`sidebar bg-white border-r border-gray-200 h-screen transition-all duration-300 ${collapsed ? 'w-20' : 'w-64'} fixed left-0 top-0 z-30`}>
      <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
        <div className={`flex items-center ${collapsed ? 'justify-center w-full' : ''}`}>
          {!collapsed && (
            <Link to="/dashboard" className="text-xl font-bold text-primary-600">
              Solia Admin
            </Link>
          )}
          {collapsed && (
            <Link to="/dashboard" className="text-xl font-bold text-primary-600">
              SA
            </Link>
          )}
        </div>
        <button
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
          onClick={toggleSidebar}
        >
          {collapsed ? <Menu /> : <ChevronLeft />}
        </button>
      </div>

      <div className="py-4 overflow-y-auto h-[calc(100vh-4rem)]">
        <div className="px-4 mb-6">
          {!collapsed && (
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-semibold">
                {currentUser?.name?.charAt(0) || 'A'}
              </div>
              <div>
                <div className="font-medium text-gray-900">{currentUser?.name || 'Admin'}</div>
                <div className="text-xs text-gray-500">{currentUser?.email || 'admin@example.com'}</div>
              </div>
            </div>
          )}
          {collapsed && (
            <div className="flex justify-center">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-semibold">
                {currentUser?.name?.charAt(0) || 'A'}
              </div>
            </div>
          )}
        </div>

        <ul className="space-y-1 px-3">
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={`flex items-center ${collapsed ? 'justify-center' : 'justify-between'} px-3 py-2 rounded-md transition-colors ${
                  location.pathname.startsWith(item.path)
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <div className={`flex items-center ${collapsed ? '' : 'space-x-3'}`}>
                  <div>{item.icon}</div>
                  {!collapsed && <span>{item.text}</span>}
                </div>
              </Link>
            </li>
          ))}
        </ul>

        <div className="px-3 mt-6">
          <button
            onClick={handleLogout}
            className={`flex items-center ${collapsed ? 'justify-center' : 'justify-between'} w-full px-3 py-2 rounded-md transition-colors text-gray-700 hover:bg-gray-100`}
          >
            <div className={`flex items-center ${collapsed ? '' : 'space-x-3'}`}>
              <div><Logout className="w-5 h-5" /></div>
              {!collapsed && <span>Déconnexion</span>}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
